import { HTTP_STATUS_MESSAGE, NATIVE_NETWORK_ERROR, DEFAULT_ERROR_MESSAGE, HTTP_STATUS_MESSAGE_RULES, } from './constant';
// 根据状态码返回错误信息
var getRuleMessageFromResponse = function (response) {
    var _a = (response || {}).status, status = _a === void 0 ? '' : _a;
    var errorMessage = HTTP_STATUS_MESSAGE[status];
    if (errorMessage) {
        return errorMessage;
    }
    var rule = HTTP_STATUS_MESSAGE_RULES.find(function (messageRule) { return messageRule.match.test("" + status); });
    if (rule) {
        return rule.message;
    }
};
// 获取业务错误信息
var getErrorMsgFromResponseData = function (response) {
    var data = response && typeof response.data === 'object' && response.data && response.data;
    if (data) {
        return data.error_msg || data.errMsg || data.errorMsg || data.message;
    }
};
// mesage   code
// Request aborted    ECONNABORTED
// maxContentLength size of xxx exceeded    null
// timeout of xxx ms exceeded   ECONNABORTED
// Network Error  null
// 错误信息优先级：error_msg > rule message 
export var getErrorMsgFromError = function (error, defaultMessage) {
    var _a = error || {}, message = _a.message, response = _a.response;
    // 非2xx的情况，也可能会有业务的error_msg
    var errorMsg = getErrorMsgFromResponseData(response);
    if (errorMsg) {
        return errorMsg;
    }
    if (error && error.isAxiosError && message) {
        if (message.indexOf('timeout') > -1) {
            return HTTP_STATUS_MESSAGE[408];
        }
        if (message.indexOf('maxContentLength') > -1) {
            return HTTP_STATUS_MESSAGE['4xx'];
        }
        if (error.name === NATIVE_NETWORK_ERROR) {
            return error.message;
        }
    }
    var ruleMessage = getRuleMessageFromResponse(response);
    return ruleMessage || defaultMessage || DEFAULT_ERROR_MESSAGE;
};
//# sourceMappingURL=error-msg.js.map